<template>
  <b-button 
    variant="primary" 
    disabled
    class="w-100" 
    @click="$emit('click')" 
    v-b-tooltip.hover 
    title="Solicitar antecipação manualmente">
    Antecipação Manual
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  name: 'ManualAnticipationButton',
  components: { BButton },
};
</script>
